
import {
  defineComponent, shallowRef, onMounted,ref,onUnmounted,
} from 'vue';
import { constructionSitesManagementLogin, } from '@/pages/logged/pages/supervise/superviseReq';

export default defineComponent({
  setup () {
    // 链接列表数据
    const linkList = [
      {
        key: '1',
        name: '南京市建设工程工地智慧监管平台',
        logo: 'logo1',
        url: 'http://www.njzhgd.cn/#/login',
      },
      {
        key: '2',
        logo: 'logo2',
        name: '工地扬尘管控系统',
        url: 'http://139.196.237.58:9610/#/login',
      },
      {
        key: '3',
        logo: 'logo3',
        name: 'OBD平台',
        url: 'https://njobd.njhb.gov.cn:8086/dashboard',
      },
      {
        key: '4',
        logo: 'logo4',
        name: '活性炭码上换',
        url: 'http://180.101.236.176:5004/webhb/login',
      },
      {
        key: '5',
        logo: 'logo5',
        name: '餐饮码上洗',
        url: 'http://msx.njhb.gov.cn:8081/dltweb/login.html',
      },
      {
        key: '6',
        logo: 'logo6',
        name: '南京市餐饮油烟在线监控系统',
        url: 'http://180.101.236.174:8400/njweb/lblogin.aspx',
      },
      {
        key: '7',
        logo: 'logo7',
        name: '南京市污染源自动监控数据监管应用系统',
        url: 'http://180.101.236.211:8400/webs/',
      },
      {
        key: '8',
        logo: 'logo8',
        name: '南京市污染源用电监控系统',
        url: 'https://180.101.236.213:8403/dnjk/a/login',
      },
      {
        key: '9',
        logo: 'logo9',
        name: '南京市高淳区智慧渣土服务平台',
        url: 'http://47.111.82.239:9091/bpm-explorer/login.html',
      },
    ];

    /**
     * @method handleJump
     * @param {string} url 要跳转的链接
     * @return {void} 处理跳转
     */
    const handleJump = (link:any) => {
      if (link.key === '1') {
        window.open(link.url, '_blank');
      } else {
        constructionSitesManagementLogin().then((data: any) => {
          const { accessToken, } = data;
          const url = `${link.url}?token=${accessToken}`;

          window.open(url, '_blank');
        });
      }
    };

    return {
      linkList,
      handleJump,
    };
  },
});
